export interface DynamicConfig {
  awsRegion: string
  cognitoClientId: string
  cognitoDomain: string
  cognitoUserPoolId: string
  mcpCognitoClientId: string
  graphqlApiUrl: string
  siteUrl: string
  rumIdentityPool: string
  rumAppMonitorId: string
  accountType: string
  customerName: string
  campaignEnabled: boolean
  insightsEnabled: boolean
  operationsEnabled: boolean
  incomingStockEnabled: boolean
  workflowsEnabled: boolean
  actionNeededEnabled: boolean
  environment: string
  idpProviders: IdpProvider[]
}

export interface IdpProvider {
  name: string
  iss?: string
}

export const GOOGLE_ISS = "https://accounts.google.com"
export const MICROSOFT_ISS = "https://login.microsoftonline.com/"

export const defaultConfig: DynamicConfig = {
  awsRegion: "",
  cognitoClientId: "",
  cognitoDomain: "",
  cognitoUserPoolId: "",
  mcpCognitoClientId: "",
  graphqlApiUrl: "",
  accountType: "",
  siteUrl: "",
  rumIdentityPool: "",
  rumAppMonitorId: "",
  customerName: "",
  campaignEnabled: false,
  insightsEnabled: false,
  operationsEnabled: false,
  incomingStockEnabled: false,
  workflowsEnabled: false,
  actionNeededEnabled: false,
  environment: "production",
  idpProviders: []
}

export const dynamicConfigUrl = "/config.json"
export const idpConfigUrl = "/idp.json"
